import { DebugService } from '../services/debug/debug.service.js';

export class _HostAppEventsService {
  constructor() {
    this.debug = new DebugService('HostAppEventsService');
  }

  hideLoaderSpinnerEvent() {
    document.dispatchEvent(
      new CustomEvent('hide-loader-spinner', {
        bubbles: true,
        composed: true,
      }),
    );
  }

  sendNextStepEvent({ step, experimentNames = [], data = '', redirect = true }) {
    const event = new CustomEvent('next-step', {
      bubbles: true,
      composed: true,
      detail: {
        step,
        experimentNames,
        data,
        redirect,
        sentFrom: 'refi-user-entry-mfe',
      },
    });
    this.debug.log('sendNextStepEvent', { event });
    document.dispatchEvent(event);
  }

  sendNextMfeEvent() {
    document.dispatchEvent(
      new CustomEvent('next-mfe', {
        bubbles: true,
        composed: true,
        detail: {
          sentFrom: 'refi-user-entry-mfe',
        },
      }),
    );
  }

  sendStartNewAppEvent() {
    document.dispatchEvent(
      new CustomEvent('start-new-app', {
        bubbles: true,
        composed: true,
        detail: {
          sentFrom: 'refi-user-entry-mfe',
        },
      }),
    );
  }

  sendResumeAppEvent(app) {
    document.dispatchEvent(
      new CustomEvent('resume-app', {
        bubbles: true,
        composed: true,
        detail: {
          app,
          sentFrom: 'refi-user-entry-mfe',
        },
      }),
    );
  }

  sendRefreshExperimentsEvent(experimentNames) {
    document.dispatchEvent(
      new CustomEvent('refresh-experiments', {
        bubbles: true,
        composed: true,
        detail: {
          mfeName: 'user-entry',
          experimentNames,
        },
      }),
    );
  }

  sendUpdatePrequalStoreEvent() {
    document.dispatchEvent(
      new CustomEvent('update-prequal-store', {
        bubbles: true,
        composed: true,
      }),
    );
  }

  goToLogin() {
    document.dispatchEvent(
      new CustomEvent('go-to-login', {
        bubbles: true,
        composed: true,
        detail: {
          sentFrom: 'refi-user-entry-mfe',
        },
      }),
    );
  }
}

export const HostAppEventsService = new _HostAppEventsService();
